import { useLocation, Link } from "react-router-dom";
import { Flame, Star, Home } from "lucide-react";
import { NAV_ITEMS } from "@/app/navigation";
import { useProgressStore } from "@/store/progressStore";
import StyleSwitcher from "@/components/StyleSwitcher";
import MobileNav from "@/components/MobileNav";

function usePageTitle(): string {
  const { pathname } = useLocation();
  if (pathname === "/" || pathname === "") return "Home";
  const match = NAV_ITEMS.find((i) => pathname.startsWith(i.path));
  return match?.label ?? "Hippo";
}

export default function TopBar() {
  const title = usePageTitle();
  const { pathname } = useLocation();
  const isHome = pathname === "/" || pathname === "";
  const progress = useProgressStore((s) => s.progress);

  return (
    <header className="sticky top-0 z-20 flex h-16 items-center justify-between border-b border-border bg-bg/70 px-4 backdrop-blur sm:px-5">
      <div className="flex items-center gap-2">
        <MobileNav />
        <Link
          to="/"
          aria-label="Back to home"
          aria-disabled={isHome}
          className={[
            "inline-flex items-center gap-1.5 rounded-lg border px-2.5 py-2 text-sm font-medium transition-colors",
            isHome
              ? "pointer-events-none border-transparent text-muted/50"
              : "border-border bg-surface text-muted hover:bg-surface-2 hover:text-text",
          ].join(" ")}
        >
          <Home className="h-[18px] w-[18px]" />
          <span className="hidden sm:inline">Home</span>
        </Link>
        <h1 className="font-display text-lg font-semibold text-text">{title}</h1>
      </div>

      <div className="flex items-center gap-2">
        <div className="hidden items-center gap-1.5 rounded-full bg-surface-2 px-3 py-1.5 text-xs font-medium text-muted sm:flex">
          <Flame className="h-4 w-4 text-accent" />
          <span>{progress.streakDays} day streak</span>
        </div>
        <div className="hidden items-center gap-1.5 rounded-full bg-surface-2 px-3 py-1.5 text-xs font-medium text-muted sm:flex">
          <Star className="h-4 w-4 text-primary" />
          <span>Lvl {progress.level} · {progress.xp} XP</span>
        </div>

        <StyleSwitcher />
      </div>
    </header>
  );
}
